import { isReadableBlock } from '../utils/dom';

export default class ContentChunking {
  constructor(bionicInstance) {
    this.chunkMap = new Map();
    this.bionicInstance = bionicInstance; // Dependency on Bionic Reading to re-apply if needed
  }

  enable() {
    if (this.chunkMap.size) return;
    const shouldReapplyBionic = this.bionicInstance && this.bionicInstance.active;
    if (shouldReapplyBionic) this.bionicInstance.disable();
    
    const candidates = Array.from(document.body.querySelectorAll('p, li, blockquote, article, section, div'));

    candidates.forEach((element) => {
      if (!isReadableBlock(element)) return;
      if (element.closest('.a11y-chunk')) return;
      const text = element.textContent ? element.textContent.trim() : '';
      if (!text) return;
      const words = text.split(/\s+/);
      if (words.length < 120) return;

      this.chunkMap.set(element, element.innerHTML);
      const chunkSize = 60;
      const wrapperTagName = element.tagName === 'P' ? 'span' : 'div';
      const wrapper = document.createElement(wrapperTagName);
      wrapper.className = 'a11y-chunk';

      const pages = [];
      for (let i = 0; i < words.length; i += chunkSize) {
        pages.push(words.slice(i, i + chunkSize).join(' '));
      }

      pages.forEach((chunkText, index) => {
        const page = document.createElement(wrapperTagName);
        page.className = `a11y-chunk__page${index === 0 ? ' is-active' : ''}`;
        page.textContent = chunkText;
        wrapper.appendChild(page);
      });

      const nav = document.createElement(wrapperTagName);
      nav.className = 'a11y-chunk__nav';
      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'a11y-chunk__btn';
      prev.textContent = 'Poprzedni';
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'a11y-chunk__btn';
      next.textContent = 'Następny';
      nav.appendChild(prev);
      nav.appendChild(next);
      wrapper.appendChild(nav);

      let pageIndex = 0;
      const updatePage = (dir) => {
        pageIndex = Math.max(0, Math.min(pages.length - 1, pageIndex + dir));
        wrapper.querySelectorAll('.a11y-chunk__page').forEach((page, idx) => {
          page.classList.toggle('is-active', idx === pageIndex);
        });
      };

      prev.addEventListener('click', () => updatePage(-1));
      next.addEventListener('click', () => updatePage(1));

      element.innerHTML = '';
      element.appendChild(wrapper);
    });

    if (shouldReapplyBionic) this.bionicInstance.enable();
  }

  disable() {
    const shouldReapplyBionic = this.bionicInstance && this.bionicInstance.active;
    if (shouldReapplyBionic) this.bionicInstance.disable();

    this.chunkMap.forEach((html, el) => {
      el.innerHTML = html;
    });
    this.chunkMap.clear();

    if (shouldReapplyBionic) this.bionicInstance.enable();
  }
}
